<!-- MODAL tomaInventario/CREAR DOC. -->
<div mdbModal #tomaInventario="mdb-modal" class="modal fade" style="overflow-y: auto;" id="basicExample" tabindex="-1"
  role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-fluid" style="width: 80%" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Toma de Inventario Físico
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="tomaInventario.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <form autocomplete="off" [formGroup]="formHeader">
          <div class="row align-items-center">
            <div class="col dato" style="max-width: 200px">
              <Strong class="title">Fecha</Strong>
              <span class="value" *ngIf="formHeader.get('fecha').value">
                {{formHeader.get('fecha').value | fecha}}
              </span>
            </div>
          </div>

          <div class="row">
            <div class="col" style="max-width: 300px">
              <div class="md-form">
                <mdb-select [options]="optionsBodega" [multiple]="false" [filterEnabled]="true" [highlightFirst]="false"
                  placeholder="Seleccionar Bodega" formControlName="bodega"></mdb-select>
                <label>Bodega</label>
                <div *ngIf="
                    formHeader.get('bodega').invalid &&
                    (formHeader.get('bodega').dirty ||
                    formHeader.get('bodega').touched)
                  ">
                  <mdb-error *ngIf="formHeader.get('bodega').hasError('required')">
                    Ingrese bodega(s)
                  </mdb-error>
                </div>
              </div>
            </div>
            <div class="col" style="max-width: 300px">
              <div class="md-form">
                <mdb-select [options]="optionsRubro" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
                  placeholder="Seleccionar Rubro" formControlName="rubro"></mdb-select>
                <label>Rubro</label>
              </div>
            </div>
            <div class="col" style="max-width: 300px">
              <div class="md-form">
                <mdb-select [options]="optionsFamilia" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
                  placeholder="Seleccionar Familia" formControlName="familia"></mdb-select>
                <label>Familia</label>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col" style="max-width: 300px">
              <mdb-checkbox formControlName="filtraSaldo">Filtrar por saldo</mdb-checkbox>
            </div>
            <div class="col" style="max-width: 300px;">
              <!-- Material inline 1 -->
              <div class="form-check form-check-inline" style="margin-right: 20px;">
                <input type="radio" class="form-check-input" id="materialInlineMayor0" [value]="TIPO_MAYOR_A_CERO"
                  formControlName="mayorCero" mdbInput />
                <label class="form-check-label" for="materialInlineMayor0">Mayores a 0</label>
              </div>

              <!-- Material inline 2 -->
              <div class="form-check form-check-inline">
                <input type="radio" class="form-check-input" id="materialInlineIgual0" [value]="TIPO_IGUAL_A_CERO"
                  formControlName="mayorCero" mdbInput />
                <label class="form-check-label" for="materialInlineIgual0">Iguales a 0</label>
              </div>
            </div>

            <div class="col">
              <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="buscarYAgregar()">
                <mdb-icon fas icon="search"></mdb-icon>
                Buscar y agregar
              </button>
            </div>
          </div>

        </form>

        <div class="row" style="border-bottom: 1px solid #dee2e6">
          <div class="col">
            <h5 class="modal-title w-100 text-left" id="myModalLabel">
              Ingreso de productos
            </h5>
          </div>
        </div>

        <form [formGroup]='formDetails' novalidate>
          <div class="row align-items-center">
            <div class="col">
              <div class="md-form mt-4">
                <input value="" type="text" id="codProduct" class="form-control" placeholder="000" required #codProduct
                  formControlName="codigo" />
                <label for="codProduct">Código de producto</label>
                <div *ngIf="
                formDetails.get('codigo').invalid &&
                (formDetails.get('codigo').dirty ||
                formDetails.get('codigo').touched)
            ">
                  <mdb-error *ngIf="formDetails.get('codigo').hasError('required')">
                    Ingrese código de producto
                  </mdb-error>
                </div>
              </div>
            </div>
            <div class="col d-flex">
              <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
                (click)="abrirModalSeleccionarProducto()">
                <mdb-icon fas icon="search"></mdb-icon>
              </button>
              <h6 class="text-info" *ngIf="productoSeleccionado" style="display: contents">
                {{ productoSeleccionado.descripcion}}
              </h6>
            </div>
            <div class="col dato">
              <div class="md-form">
                <mdb-select [options]="optionsFormato" [filterEnabled]="true" [highlightFirst]="false"
                  placeholder="Seleccionar Formato" formControlName="formato"></mdb-select>
                <label>Formato</label>
                <div *ngIf="
                formDetails.get('formato').invalid &&
                (formDetails.get('formato').dirty ||
                formDetails.get('formato').touched)
            ">
                  <mdb-error *ngIf="formDetails.get('formato').hasError('required')">
                    Ingrese formato
                  </mdb-error>
                </div>
              </div>
            </div>

            <div class="col">
              <button size="sm" class="btn btn-sm" type="button" mdbBtn color="info" mdbWavesEffect
                (click)="agregarProducto()">
                Agregar
              </button>
            </div>
          </div>
        </form>

        <table class="table table-striped table-hover table-sm align-middle" *ngIf="detalleDocumento?.length > 0">
          <thead class="grey lighten-2">
            <tr>
              <th scope="col">
                <mdb-checkbox (change)="checkAllChange($event)"></mdb-checkbox>
              </th>
              <th scope="col">SKU</th>
              <th scope="col">Producto</th>
              <th scope="col">Bodega</th>
              <th scope="col">Rubro</th>
              <th scope="col">Familia</th>
              <th scope="col">Formato</th>
              <th scope="col" class="text-right">Saldo actual</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let doc of detalleDocumento">
              <td>
                <mdb-checkbox [checked]="doc.additionalInfo.checked" (change)='checkDetalle(doc.additionalInfo)'>
                </mdb-checkbox>
              </td>
              <td>{{doc.sku}}</td>
              <td>{{doc.producto_nombre}}</td>
              <td>{{doc.bodega_nombre}}</td>
              <td>{{doc.rubro_nombre}}</td>
              <td>{{doc.familia_nombre}}</td>
              <td>{{doc.formato_nombre}}</td>
              <td align="right">{{doc.saldo_actual | numerico}}</td>
              <td class="text-right">
                <button class="btn-actions-sm" color="primary" mdbBtn type="button" mdbWavesEffect
                  (click)="eliminarProducto(doc.additionalInfo.index)">
                  <mdb-icon fas icon="trash"></mdb-icon>
                </button>
              </td>
            </tr>
          </tbody>
          <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
            *ngIf="detalleDocumento?.length > 0"></app-pagination>
        </table>
        <div class="row" *ngIf="detalleDocumento?.length > 0">
          <div class="col">
            <button type="button" size="sm" class="btn btn-sm btn-warning waves-light" data-dismiss="modal"
              mdbWavesEffect (click)="eliminarProductosSeleccionados()">
              Eliminar
            </button>
          </div>
        </div>
      </div>
      <div class="modal-footer justify-content-between">
        <button size="sm" type="button" class="btn btn-sm btn-default waves-light" data-dismiss="modal"
          (click)="closeModal()" mdbWavesEffect>
          Cerrar
        </button>
        <div class="">
          <!-- <button size="sm" type="button" class="btn btn-sm btn-success waves-light" mdbWavesEffect (click)="generarArchivoExcel()"
            *ngIf="mode === 'EDIT'">
            Exportar a Excel
          </button> -->
          <app-api-button *ngIf="mode === 'ADD'" (click2)="guardar()" [processing]="processing">Guardar</app-api-button>
          <app-api-button *ngIf="mode === 'EDIT'" (click2)="editar()" [processing]="processing">Guardar</app-api-button>
          <!-- <button size="sm" type="button" class="btn btn-sm btn-secondary waves-light" mdbWavesEffect
            (click)="guardar()" *ngIf="mode === 'ADD'">
            Guardar
          </button>
          <button size="sm" type="button" class="btn btn-sm btn-secondary waves-light" mdbWavesEffect (click)="editar()"
            *ngIf="mode === 'EDIT'">
            Guardar
          </button> -->
        </div>
      </div>
    </div>
  </div>
</div>

<!-- MODAL seleccionarProducto -->
<app-modal-seleccionar-producto [showFiltroActivoInactivo]="false" (onSelect)="onProductoSeleccionado($event)"
  (onNotFound)="onProductoNoEncontrado()">
</app-modal-seleccionar-producto>
